import Typesense from 'typesense';

const url = process.env.NEXT_PUBLIC_TYPESENSE_URL;
const orgId = process.env.NEXT_PUBLIC_API_KEY;
const env = process.env.NEXT_PUBLIC_TYPESENSE_ENV;

if (!url) throw new Error('TYPESENSE_URL is not set');
if (!orgId) throw new Error('NEXT_PUBLIC_API_KEY is not set');
if (!env) throw new Error('NEXT_PUBLIC_TYPESENSE_ENV is not set');
export const typesense = new Typesense.Client({
  nodes: [
    {
      host: url.replace('https://', ''),
      port: 443,
      protocol: 'https',
    },
  ],
  apiKey: orgId,
});

export const getIndexName = (contentForm: string) => `${orgId}:${env}:${contentForm}`;
